let waitForPressResolve;

export const waitForPress = () => {
    return new Promise(resolve => waitForPressResolve = resolve);
}

export const btnResolver = () => {
    if(waitForPressResolve) waitForPressResolve()
}